var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"to":_vm.url}},[_c('b-button',{staticClass:"d-flex align-items-center",attrs:{"variant":"primary","size":_vm.size}},[_c('span',{staticStyle:{"white-space":"nowrap"}},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"d-flex ml-1 small icon-chevron-thin-right"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }